export const PAGE_SIZE = 100
export const ACTIVITY_DAYS = 30
export const DASHBOARD_STALE_TIME = 10 * 60 * 1000
